var myGallery;
$(document).ready(function(){
    $('#order-start_form').submit(function() {
        document.dispatchEvent(new Event('OrderStart'));
    });
    $('#order-finish_form').submit(function() {
        document.dispatchEvent(new Event('OrderFinish'));
    });
    $("#main-slider").owlCarousel({
        nav: true,
        dots: true,
        items: 1,
        navText: [
            '<i class="sprite sprite-home_31"></i><i class="sprite sprite-home_31_active"></i>',
            '<i class="sprite sprite-home_34"></i><i class="sprite sprite-home_34_active"></i>'
        ]
    });

    $('.additional-images').owlCarousel({
        items : 2,
        responsive : {
            640 : { items : 3  },
            1280 : { items : 4 }
        },
        // items: 4,
        navigation: true,
        center: false,
        navigationText : [
            '<i class="sprite sprite-img_88-min"></i><i class="sprite sprite-img-hover_10-min"></i>',
            '<i class="sprite sprite-img_91-min"></i><i class="sprite sprite-img-hover_13-min"></i>'
        ],
    });
    // Change product image on thumbnail mouseover
    $('.additional-images a').mouseover(function(){
        var el = $('#main-image');
        var href = $(this).attr('href');
        el.find('img').attr('src', href);

        $('.fancybox-thumbs').removeClass('selected');
        $(this).addClass('selected');
    });
    $('.additional-images a').click(function(e){
        e.preventDefault();
        // var ind = $(".gallery-image").index($(this));
        var ind = $('.additional-images .selected').parent().index();
        myGallery.openGallery(ind);
        return false;
    });
    // Main image click
    $('#main-image').click(function(e){
        e.preventDefault();
        $('.additional-images .selected').trigger('click');
        return false;
    });

    // Products carousel
    var i;
    for(i=1;i<=$('.products-carousel').length;i++) {
        var carousel = $('#products-carousel-' + i);
        carousel.owlCarousel({
            items : 4,
            responsive : {
                0 : {
                    items : 1,
                },
                460: {
                    items : 2,
                },
                691: {
                    items : 3,
                },
                1241: {
                    items : 4,
                }
            },
            lazyLoad : true,
            dots: false,
            navText : [
                '<i class="sprite sprite-home_39"></i><i class="sprite sprite-home_39_active"></i><div class="shadow"></div>',
                '<i class="sprite sprite-home_42"></i><i class="sprite sprite-home_42_active"></i><div class="shadow"></div>'
            ],
            nav : true,
            pagination : false,
            itemsDesktop : false,
            itemsDesktopSmall : false,
            itemsTablet: false,
            itemsMobile : false
        });

        // Auto height
        autoHeightCarousel(carousel);
    }

    // News show full text
    $(".news-full-text").click(function(){
        $(this).parent().toggleClass("active");
    });
    // News show all news
    $("#more-news").click(function(){
        var news = $(this).parent();
        news.toggleClass("active");
        if(!news.hasClass("active")){
            $("html, body").animate({
                scrollTop: news.offset().top
            }, 600);
        }
    });

    // Scroll up button
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $('.scrollup').fadeIn();
        } else {
            $('.scrollup').fadeOut();
        }
    });

    $('.scrollup').click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });

    // Product card amount change
    $('#reduce-amount, .reduce-amount').click(function(){
        var a = $(this).parent().find('input');
        var v = a.val();
        if(v > 1)
            a.val(+v - 1);

        // refresh cart
        a.trigger('change');

        if($(this).hasClass('popup'))
            $('#popup-amount-input').trigger('change');
        return false;
    });
    $('#increase-amount, .increase-amount').click(function(){
        var a = $(this).parent().find('input');
        a.val(+a.val() + 1);

        // refresh cart
        a.trigger('change');

        if($(this).hasClass('popup'))
            $('#popup-amount-input').trigger('change');
        return false;
    });
    $('#popup-amount-input').change(function(){
        changeCartAmount($(this).data('id'), $(this).val());
        var s = $('#popup-sum');

    });

    // Listing auto height
    var listing = $('#products-listing');
    if(listing) {
        autoHeightListing(listing);
    }

    // Call back popup
    $(".callBackOpen").click(function(){
        var myModal = new SimpleModal("modal-callBack");
        myModal.open();
    });

    // Call back send
    $('#form-callBack').submit(function(e){
        e.preventDefault();
        var b = $(this).parent();
        var postData = $(this).serialize();
        $.post('/custom/mail_ajax.php', postData, function(data){
            b.html(data.message);
			if (typeof ingEvents !== "undefined") {
				ingEvents.init({
					idsYM: ['53080006']
				});
				ingEvents.listTrackers();
				ingEvents.YMReachGoal({type: 'event', label: 'callback'});
			}
        },'json');
    });

    // Aside collapsed switch on cart pages
    $('#open-aside').click(function(){
        $('aside.left').toggleClass('collapsed');
        $('section.right').toggleClass('full_width');
        $('.need_full_width').toggleClass('full_width');
    });

    // Gallery image
    myGallery = new SimpleModal("modal-image-gallery");
    myGallery.createGallery();

    $(".gallery-image").click(function(e){
        e.preventDefault();
        // var ind = $(".gallery-image").index($(this));
        var ind = $('.additional-images .selected').parent().index();
        myGallery.openGallery(ind);
        return false;
    });

});


function autoHeightCarousel(carousel) {
    var h = carousel.outerHeight();
    var n = carousel.find('.name');
    var i,m = 0;
    n.each(function(){
        var h2 = $(this).outerHeight();
        if(h2 > m)
            m = h2;
        i++;
    });
    n.each(function(){
        $(this).css('height', m + 'px');
    });
    carousel.css('height', h + 'px');
}

function autoHeightListing(products) {
    var n = products.find('.name');
    var i, m = 0, h3;

    n.each(function(){
        var h2 = $(this).outerHeight();
        if(h2 > m) {
            m = h2;
            h3 = $(this).closest('li').outerHeight();

        }
        i++;
    });
    n.each(function(){
        $(this).css('height', m + 'px');
    });
    products.find('li.column').each(function(){
        $(this).css('height', h3 + 'px');
    });
}

/*
 modalId - modal window id
 */
function SimpleModal(modalId) {
    this.modal = document.getElementById(modalId);
    this.closeBtn = this.modal.getElementsByClassName("close");
    this.onClose = null;
    this.gallery = [];
    this.galleryInd = 0;
    this.galleryClass = 'gallery-image';

    var modal = this.modal,
        this2 = this;

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
        if (event.target == modal) {
            this2.close();
        }
    };

    // When the user clicks on <span> (x), close the modal
    Array.prototype.forEach.call(this.closeBtn,function(el){
        el.onclick = function(e) {
            e.preventDefault();
            this2.close();

            // Fix Safari bug when changing location
            //  - xmlHttp.responseText = ''
            //  - xmlHttp.responseXML = null
            setTimeout(function() {
                if(typeof el.href != 'undefined') window.location.href = el.href;
            }, 500);
        };
    });

    this.open = function() {
        this.modal.style.display = "block";
    };

    this.close = function() {
        this.modal.style.display = "none";
        if(this.onClose)
            this.onClose();
    };

    this.createGallery = function(galleryClass) {
        // change default gallery image class
        if(typeof galleryClass == 'undefined')
            galleryClass = this.galleryClass;
        else
            this.galleryClass = galleryClass;

        // collect all gallery images
        var g = document.getElementsByClassName(galleryClass);
        Array.prototype.forEach.call(g,function(el){
            this2.gallery.push(el.href);
        });

        // enable controls
        if(this.gallery.length > 1) {
            var controls = document.getElementById('gallery-controls');
            controls.style.display = 'block';
            var next = controls.getElementsByClassName('gallery-next')[0],
                prev = controls.getElementsByClassName('gallery-prev')[0];

            if(typeof next == 'undefined' || typeof prev == 'undefined')
                return false;

            next.onclick = function(e) {
                if( (this2.galleryInd + 1) < this2.gallery.length ) {
                    this2.galleryInd = this2.galleryInd + 1;
                }
                else {
                    this2.galleryInd = 0;
                }
                this2.openGallery(this2.galleryInd);
            };

            prev.onclick = function(e) {
                if( (this2.galleryInd - 1) < 0 ) {
                    this2.galleryInd = this2.gallery.length - 1;
                }
                else {
                    this2.galleryInd = this2.galleryInd - 1;
                }
                this2.openGallery(this2.galleryInd);
            };

        }
    };

    this.openGallery = function(ind) {

        if(typeof ind == 'undefined')
            ind = 0;

        this.galleryInd = ind;
        document.getElementById('gallery-active-image').src = this.gallery[ind];

        this.open();
    };


}

$('.js-toggle-nav').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('navicon--active');
    $('.toggle').toggleClass('toggle--active');
    $('header .middle').toggleClass('active');
});

//css media query trigger
function resize() {
    // less thane 760px screen
    if ( window.innerWidth < 961) {
        $('aside > .wrapper_catalog > .categories_list').appendTo('#m-cat_nav > li');
        $('#m-cat_nav .categories_list').addClass('level-2');
        $('.middle .navigation_offers').insertAfter('#m-cat_nav');
        var $addedDiv = $(".back-track");
        if ($addedDiv.length == 0) {
            $('#m-cat_nav .categories_list').prepend('<a href="#" class="back-track">Назад <i class="sprite sprite-home_31"></i></a>');
        }
    }
    else {
        $('#m-cat_nav .categories_list').appendTo('aside > .wrapper_catalog');
        $('aside > .wrapper_catalog > .categories_list').removeClass('level-2');
        $('.middle .navigation_offers').insertAfter('.middle .search');
        $('.categories_list .back-track').remove();
    }
    // less thane 640px screen
    if ( window.innerWidth < 641) {
    }
    else {
    }
    // less thane 480px screen
    if ( window.innerWidth < 481) {
    }
    else {
    }
}
$(window).on("resize", resize);
resize();

//level menu start****************
$('.level-1 li > .level-2').parent().addClass('has-subnav');
/*$('.level-1 li.has-subnav > a').each(function() {
    var $this = $(this);
    var myClone = $this.clone();
    var myCloneParent = $this.next('.level-2');
    myClone.prependTo(myCloneParent).addClass('back-track').wrap('<li></li>');
});*/
$('.level-1 li.has-subnav > a').click(function() {
    var $this = $(this);
    $this.next('.level-2').addClass('active');
    $this.parent().parent().addClass('active');
    if($this.parent().parent().hasClass('active')){
        $this.next('.level-2').css({'overflow':'auto'});
    }
    if($this.next('.level-2').hasClass('active') == false){
        $this.next('.level-2').css('display','none');
    }
    if($this.parent().parent().parent().hasClass('active')){
        $('#single-level').css('display', 'none');
    }
});
$('.level-1 a.back-track').click(function() {
    var $this = $(this);
    $this.parent().removeClass('active');
    $this.parent().parent().parent().removeClass('active');
    console.log($this.parent().parent().parent().hasClass('active'));
    if($this.parent().parent().parent().hasClass('active') == false){
        $('#single-level').css('display', 'block');
    }
});
//level menu end*******************

function validateEmail(email){
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return email.match(mailformat) ? true : false;
}

$(document).ready(function(){
    var $b = $('body'),
        extras;

    $b.on('keyup, change', '.js-user-email', function(e){
        var $this = $(this),
            email = $this.val();
        // if(!extras)
        //     getFastOrderProduct($this);

        if(validateEmail(email)) {
            $.post('/modules/goods_cart/wasted.php', {email: email, extras: extras, action: 'update'}, null, 'json');
        }
    });

    $b.on('keyup, change', '.js-user-phone', function(e){
        var $this = $(this),
            phone = $this.val();
        // if(!extras)
        //     getFastOrderProduct($this);

        if(phone.length > 9){
            $.post('/modules/goods_cart/wasted.php', {phone: phone, extras: extras, action: 'update'}, null, 'json');
        }
    });

    $b.on('keyup, change', '.js-user-name', function(e){
        var $this = $(this),
            name;
        // if(!extras)
        //     getFastOrderProduct($this);

        $('.js-user-name').each(function(){
            var v = $(this).val();
            if(v){
                if(name){
                    name = name + ' ' + v;
                }
                else {
                    name = v;
                }
            }
        });
        if(name.length > 1){
            $.post('/modules/goods_cart/wasted.php', {name: name, extras: extras, action: 'update'}, null, 'json');
        }
    });

    // If this is fast order, then add product data
    function getFastOrderProduct($this){
        if($this.hasClass('js-fast-order')){
            var form = $this.closest('form'),
                product = form.find('input[name="product[]"]'),
                amount = form.find('input[name="amount[]"]'),
                price = form.find('input[name="price[]"]');
            if(product !== 'undefined' && amount !== 'undefined' && price !== 'undefined'){
                extras = {fast_order: {name: product[0].value, amount: amount[0].value, price: price[0].value}};
            }
        }
        return false;
    }

    var recCart,
        recButton = $('#js-recalculate-cart');
    $b.on('change input', '.js-cart-good-amount', function(){
        clearTimeout(recCart);
        recCart = setTimeout(function(){
            recButton.trigger('click');
        }, 1000);
    });
});